import React from "react";
import Filters from "./Filters";
import ListTemplate from "components/ListTemplate";
import { cardLayout } from "./cardLayout";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import TrainModal from "train/TrainModal";
import { useLoaderData } from "react-router";

const FlightListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.FlightListFrontModel>();

  return <>
    <TrainModal />
    <ListTemplate
      title={RESX.Flight.Flights}
      filterSet="flight_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.Flight.Paginated}
      getId={item => item.flightId}
      layout={cardLayout()}
      filters={<Filters />}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
    />
  </>
};

export default FlightListApp;
